/**
 * Dashboard - User's settings
 */

'use strict';

var helpers = require('../misc/helpers');

// Constructor
var FrontDashboardSettings = function () {
    if (!$('body').hasClass('dashboard-settings')) {
        return;
    }

    $(document).ready((function() {
        this.formNewsletter();
        this.formUserSettings();
        this.formAskProAccess();
        this.formPrivacy();
    }).bind(this));
};

FrontDashboardSettings.prototype = {
    lockAjaxSendForm: false,

    /**
     * Update the user's newsletter subscription options.
     */
    formNewsletter: function() {
        var self = this;
        var form = $('#newsletter-form');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxSendForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxSendForm = true;

            $('.btn-submit', form).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=dashboard.newsletter&security=" + comedien.security,
            }).done(function(response) {
                var msg = '';

                if (response.success) {
                    msg = comedien.i18n.optionsSaved;
                } else {
                    msg = comedien.i18n.anErrorOccured;
                }

                M.toast(msg, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            }).fail(function(jqXHR, textStatus) {
                M.toast(comedien.i18n.anErrorOccured, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            });
        });
    },

    /**
     * Update the user's account settings (password and email address).
     */
    formUserSettings: function() {
        var self = this;
        var form = $('#user-settings-form');

        // Password strength meter
        //this.initPasswordStrenghMeter();

        // Check the password complexity (without using the zxcvbn library... what's a pitty... :/)
        this.initPasswordCheckComplexity();

        // Password confirmation
        $('#confirm-password').on('input', function() {
            if ($(this).val() !== $('#new-password').val()) {
                $(this).removeClass('valid').addClass('invalid');
            } else {
                $(this).removeClass('invalid').addClass('valid');
                $(this).blur();
            }
        });

        // Forum submission
        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxSendForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxSendForm = true;

            $('.btn-submit', form).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=dashboard.userssettings&security=" + comedien.security,
            }).done(function(response) {
                if (response.success) {
                    M.toast(comedien.i18n.optionsSavedLogout, 5000);
                    M.toast(comedien.i18n.hasBeenLogout, 5000);
                    setTimeout(function() {
                        location.reload();
                    }, 3000);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        var input = $('#' + i, form);
                        if (input.length > 0) {
                            input.addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        }
                    });
                }

                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            }).fail(function(jqXHR, textStatus) {
                M.toast({html:'<span>'+ comedien.i18n.anErrorOccured +'</span>'}, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            });
        });
    },

    /**
     * Initialize the password strength meter (with zxcvbn).
     */
    initPasswordStrenghMeter: function() {
        var newPassword = $('#user-settings-form #new-password');

        if (!newPassword.length > 0) {
            return;
        }

        newPassword.on('input', function() {
            var password = $(this).val();
            var blacklist = ['comédien', 'comedien', 'acteur', $('#user-settings-form #firstname').val(), $('#user-settings-form #lastname').val(), $('#user-settings-form #email').val()];

            if (password.length == 0) {
                newPassword.removeClass('force-invalid').removeClass('force-warning').removeClass('force-valid');
                $('.pwd-strength').hide();
            } else {
                var result = zxcvbn(password, blacklist);

                switch (result.score) {
                    case 0:
                        newPassword.removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                        $('.pwd-strength span').text(comedien.i18n.signupPwdStrength1);
                        $('.pwd-strength').show();
                        break;
                    case 1:
                        newPassword.removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                        $('.pwd-strength span').text(comedien.i18n.signupPwdStrength1);
                        $('.pwd-strength').show();
                        break;
                    case 2:
                        newPassword.removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                        $('.pwd-strength span').text(comedien.i18n.signupPwdStrength2);
                        $('.pwd-strength').show();
                        break;
                    case 3:
                        newPassword.removeClass('force-valid').removeClass('force-invalid').addClass('force-warning');
                        $('.pwd-strength span').text(comedien.i18n.signupPwdStrength3);
                        $('.pwd-strength').show();
                        break;
                    case 4:
                        newPassword.removeClass('force-invalid').removeClass('force-warning').addClass('force-valid');
                        $('.pwd-strength').hide();
                        break;
                }
            }
        });
    },

    initPasswordCheckComplexity: function() {
        // Check if the password contain the required char (uppercase, min 8 char, etc.)
        var check = function() {
            var password = $('#user-settings-form #new-password').val();

            var blacklist = [$('#user-settings-form #firstname').val(), $('#user-settings-form #lastname').val(), $('#user-settings-form #email').val()];

            var patternEmail = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
            var inputEmail = $('#user-settings-form #email').val();
            if (patternEmail.test(inputEmail)) {
                var username = inputEmail.substring(0, inputEmail.lastIndexOf("@"));
                blacklist.push(username); // Add the part before the "@"
            }

            blacklist = helpers.cleanArray(blacklist);

            var result = true;

            // Check the password length
            if (password.length < 8) {
                result = false;
            }

            // Check if the password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) == null) {
                result = false;
            }

            // Check blacklisted words

            if (blacklist.length > 0) {
                var regex = new RegExp(blacklist.join("|"), "gi");
                if (password.match(regex)) {
                    result = false;
                }
            }

            if (result == true) {
                // The password is valid
                $('#user-settings-form #new-password').removeClass('force-invalid').removeClass('force-warning').addClass('force-valid');
                $('#user-settings-form #confirm-password').val('').attr('disabled', false);
            } else {
                // The password is invalid
                $('#user-settings-form #new-password').removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                $('#user-settings-form #confirm-password').val('').attr('disabled', 'disabled').removeClass('valid').removeClass('invalid');
            }
        };

        $('#user-settings-form #new-password').on('input', function() {
            check();
        });
    },

    /**
     * Send a request to the administrator to get a pro access.
     */
    formAskProAccess: function() {
        var self = this;
        var form = $('#professional-access-form');

        $('textarea#application').characterCounter();

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxSendForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxSendForm = true;

            $('.btn-submit', form).addClass('disabled');

            $('.result-asked').hide();
            $('.result-accepted').hide();
            $('.result-refused').hide();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=dashboard.askproaccess&security=" + comedien.security,
            }).done(function(response) {
                var msg = '';

                if (response.success) {
                    msg = comedien.i18n.askProAccessSuccess;
                    form.fadeOut();
                    $('.toHideIfSuccess').fadeOut();

                    $('.result-asked').fadeIn();
                    $('.result-accepted').hide();
                    $('.result-refused').hide();
                } else {
                    msg = comedien.i18n.askProAccessError;
                }

                M.toast(msg, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            }).fail(function(jqXHR, textStatus) {
                M.toast(comedien.i18n.anErrorOccured, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            });
        });
    },


    /**
     * Update the user's policies options.
     */
    formPrivacy: function() {
        var self = this;
        var form = $('#user-privacy-form');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxSendForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxSendForm = true;

            $('.btn-submit', form).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=dashboard.account.privacy&security=" + comedien.security,
            }).done(function(response) {
                var msg = '';

                if (response.success) {
                    msg = comedien.i18n.optionsSaved;
                } else {
                    msg = comedien.i18n.anErrorOccured;
                }

                M.toast(msg, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            }).fail(function(jqXHR, textStatus) {
                M.toast(comedien.i18n.anErrorOccured, 5000);
                $('.btn-submit', form).removeClass('disabled');

                self.lockAjaxSendForm = false;
            });
        });
    },
};

module.exports = new FrontDashboardSettings();
